import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import {renderAdmin} from '../Common/Utilities';
import PickHistory from './PickHistory';

import * as _ from 'lodash';

import "./Draft.css";

function getDefaultChampImage() {
    return "https://i.imgur.com/itD4MJz.jpg";
}

class Draft extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.renderPicks = this.renderPicks.bind(this);
    }

    renderPicks(round) {
        let picksOutput = [];
        let component = this;
        if (!_.isEmpty(round.picks)) {
            round.picks.forEach((pick, pickIndex) => {
                picksOutput.push(
                    <PickHistory key={`pick-${pickIndex}`} pick={pick} pickIndex={pickIndex}
                                 teams={component.props.teams}/>
                );
            });
        }
        return picksOutput;
    }

    renderRounds(rounds) {
        let roundsOutput = [];
        if (!_.isEmpty(rounds)) {
            rounds.forEach((round, roundIndex) => {
                roundsOutput.push(
                    <div key={`round-${roundIndex}`} className="col-12 pl-4">
                        <h5>Round {roundIndex + 1}</h5>
                        {this.renderPicks(round)}
                    </div>
                );
            });
        }
        return roundsOutput;
    }

    render() {
        let draft = this.props.draft;
        let team = this.props.teams[this.props.draft.championTeamId]
        return (
            <div className={(this.state.show ? "col-12" : "col-12 col-sm-6 col-md-4 col-lg-3 card-group mt-4")}>
                <div className="card" key={draft.id}>
                    <img className={"card-img-top center-crop " + (this.state.show ? "full-draft-image" : "small-draft-image")} src={team && team.imageURL ? team.imageURL : getDefaultChampImage()} alt="Team" />
                    <div className="card-body">
                        <h5 className="card-title">{draft.year}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">{team && team.owner}</h6>
                        <p className="card-text">{draft.recap}</p>
                        <button className={"card-link btn btn-link"} onClick={()=>{
                            this.setState({
                                show: !this.state.show
                            })
                        }}>{(this.state.show ? 'Hide' : 'Show') + ' Draft Recap'}</button>
                        <Link className={"card-link btn btn-link " + renderAdmin(this.props.isAdmin)} to={`/create-draft/${draft.id}`}>Edit</Link>
                        <div className={"row" + (this.state.show ? "" : " d-none")}>
                            {this.renderRounds(draft.rounds)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Draft;



// WEBPACK FOOTER //
// ./src/components/Draft/Draft.js